import React, { useEffect, useRef } from 'react';

// Animated ember/spark particle canvas for hero
export default function ParticleField({ className = '' }) {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let raf;
    let w, h;
    const particles = [];
    const COUNT = 60;

    const resize = () => {
      w = canvas.width = canvas.offsetWidth * window.devicePixelRatio;
      h = canvas.height = canvas.offsetHeight * window.devicePixelRatio;
    };
    resize();
    window.addEventListener('resize', resize);

    for (let i = 0; i < COUNT; i++) {
      particles.push({
        x: Math.random() * w,
        y: h + Math.random() * h * 0.5,
        r: Math.random() * 2 + 0.6,
        vy: -(Math.random() * 0.6 + 0.2),
        vx: (Math.random() - 0.5) * 0.3,
        life: Math.random(),
        maxLife: Math.random() * 200 + 200,
      });
    }

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.life += 1;
        if (p.y < 0 || p.life > p.maxLife) {
          p.y = h + 10;
          p.x = Math.random() * w;
          p.life = 0;
        }
        const alpha = 1 - p.life / p.maxLife;
        const grad = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 6);
        grad.addColorStop(0, `rgba(244, 216, 150, ${0.85 * alpha})`);
        grad.addColorStop(0.4, `rgba(228, 180, 78, ${0.35 * alpha})`);
        grad.addColorStop(1, 'rgba(228, 180, 78, 0)');
        ctx.fillStyle = grad;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * 6, 0, Math.PI * 2);
        ctx.fill();
      });
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return <canvas ref={ref} className={`absolute inset-0 w-full h-full pointer-events-none ${className}`} />;
}
